<h1>{{ 'academy.Videos_published'|translate }}</h1>
<div class="videos">
	<div class="videos-info">
		<p [innerHTML]="'academy.Want_to_do_some_modification'|translate: {support: ':support'}"></p>
	</div>


	<div class="lectures" *ngIf="videosPublished">
		<div class="row">
			<div class="lecture-items col-12 col-md-6" *ngFor="let video of videosPublished">
				<app-lecture  [card]="true" [lecture]="video" [user]="user" [favoriteElement]="false"></app-lecture>
			</div>
		</div>
	</div>
  <div *ngIf="noResults" class="row d-flex justify-content-center">
    <p>{{'academy.No_results_found' | translate}}</p>
  </div>
  <app-loader *ngIf="loading"></app-loader>
</div>

